import axios from "axios";
import {BASE_PATH} from "../services/api";

const getCalculations = async (store_code) => {
    return axios.get(
        BASE_PATH + "/admin/get-calculations/" + store_code,
        {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        }
    );
};

const getReports = async (calculations) => {
    const ids = calculations.map(item => item.id);
    return axios.get(
        BASE_PATH + "/admin/get-reports/" + JSON.stringify(ids),
        {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        }
    );
}

const postCalculation = async (formData) => {
    return axios.post(BASE_PATH + "/admin/post-calculation", formData, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
        },
    });
};

export {getCalculations, postCalculation, getReports};
